var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilledon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.277 3.584A.5.5 0 0 0 6.5 4v16a.5.5 0 0 0 .777.416l12-8a.5.5 0 0 0 0-.832l-12-8Z",
  fill: "currentColor"
})));
export { SvgFilledon as ReactComponent };
export default __webpack_public_path__ + "292352e404ec017258802e6f03192173.svg";